import { IconButton, TableCell, TableRow, TextField, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import React, { ChangeEvent, FC } from 'react'
import { useDispatch } from 'react-redux'
import { DefaultLittleMessage } from '@root-gipro/constants/constants'
import {
  patchProjectOA,
  setProjectDeleteModalOA,
  setProjectOAInputs
} from '@root-gipro/modules/userProjects/store/actions'

const ProjectRpcRow: FC<{
  objectAnalog: any
}> = ({
  objectAnalog
}) =>   {

  const dispatch = useDispatch();

  const onDeleteOAHandler = (idObjectAnalog: number) => {
    dispatch(setProjectDeleteModalOA({
      isOpen: true,
      idObjectAnalog,
    }));
  };

  const onInputChangeHandler = (
    e: ChangeEvent<HTMLInputElement|HTMLTextAreaElement>,
    idObjectAnalog: any,
    idConnectProjectAndOA: any,
    name: string,
  ) => {

    dispatch(setProjectOAInputs({
      idObjectAnalog,
      value: e.target.value,
      name
    }));

    dispatch(patchProjectOA({
     idConnectProjectAndOA,
      
     count: name === 'count' ? e.target.value : objectAnalog.count,
     comment: name === 'comment' ? e.target.value : objectAnalog.comment,
   }));
  };

  return (
    <TableRow className='adminPanel__tableRow'>
      <TableCell
        className='adminPanelCell__solution'
        align='center'
        style={{ width: '10%' }}
      >
        <IconButton
          size='small'
          aria-label='Удалить'
          data-popup='delete_solution'
          onClick={() => onDeleteOAHandler(objectAnalog?.idConnectProjectAndOA)}
        >
          <DeleteIcon fontSize='small' />
        </IconButton>
      </TableCell>

      <TableCell
        className='adminPanelCell__solution'
        align='center'
        style={{ width: '10%' }}
      >
        {objectAnalog.id}
      </TableCell>

      <Tooltip title={objectAnalog.name}>
        <TableCell
          className='adminPanelCell__solution'
          style={{ width: '35%' }}
        >
          <div className='adminPanelCell__solution_name'>
            {objectAnalog.name}
          </div>
        </TableCell>
      </Tooltip>

      <Tooltip title={objectAnalog?.th_name || DefaultLittleMessage}>
        <TableCell
          align='center'
          style={{ width: '20%' }}
        >
          {objectAnalog?.th_name || DefaultLittleMessage}
        </TableCell>
      </Tooltip>

      <TableCell
        align='center'
        style={{ width: '10%' }}
      >
        <TextField
          type='number'
          inputProps={{
            style: {
              paddingRight: '8px',
            },
            min: 0
          }}
          value={objectAnalog?.count}
          variant='outlined'
          onChange={(e) => onInputChangeHandler(e, objectAnalog.id, objectAnalog.idConnectProjectAndOA, 'count')}
        />
      </TableCell>

      <TableCell
        align='center'
        style={{ width: '15%' }}
      >
        <TextField
          value={objectAnalog?.comment}
          variant='outlined'
          onChange={(e) => onInputChangeHandler(e, objectAnalog.id, objectAnalog.idConnectProjectAndOA, 'comment')}
        />
      </TableCell>
      
      <TableCell
        align='center'
        style={{ width: '10%' }}
      >
        {objectAnalog?.th_unit || DefaultLittleMessage}
      </TableCell>

      <TableCell
        align='center'
        style={{ width: '20%' }}
      >
        {objectAnalog.total === 0
          ? objectAnalog.total
          : (objectAnalog.total ? Intl.NumberFormat('ru-RU').format((objectAnalog.total * objectAnalog.count) / 1000) : DefaultLittleMessage)}
      </TableCell>
    </TableRow>
  )
};

export default ProjectRpcRow;
